import { routeNames } from "@/configs/routePaths";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Alert, Button, Label, Modal } from "flowbite-react"
import { useNavigate } from "react-router-dom";

interface IEnvioSucessoDevolucaoEmMassaModalProps {
  onClose: () => void
  isOpen: boolean
}

const EnvioSucessoDevolucaoEmMassaModal: React.FC<IEnvioSucessoDevolucaoEmMassaModalProps> = ({
  onClose,
  isOpen,
}) => {
  const navigate = useNavigate();

  return (
    <Modal show={isOpen} size="xl" onClose={onClose}>
      <Modal.Body>
        <div className='mb-5 text-center'>
          <Alert color={'success'} className='flex items-center'>
            <div className='flex flex-col justify-center items-center gap-2 mb-4'>
              <CheckCircleIcon className='md:w-8 md:h-8 w-12 h-12 text-green-500' />
              <span className='block text-center text-2xl font-semibold'>
                Sua planilha foi enviada para o processamento.
              </span>
              <Label className='block mt-4 text-gray-600 leading-7 text-center'>
                Para acompanhar o status e a tratativa das devoluções, acesse
                a aba <strong>Registro de Devoluções</strong> no menu superior.
              </Label>
            </div>
          </Alert>
        </div>
        <div className='flex gap-2 justify-center items-center'>
          <Button
            onClick={() => {
              onClose()
              navigate(`/${routeNames.registro}`)
            }}
            color='gray'
          >Fechar</Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default EnvioSucessoDevolucaoEmMassaModal
